export default import.meta.ROLLDOWN_FILE_URL_vtzvxJUM1w5hN9mpTI7UHA